export const chat = `0 Rumms! -> 1
1 Klonk -> 2
2 Ups. -> 3
3 Entschuldigung. 🤭 -> 4
4 Ich habe mich gerade neu platziert. 😌 -> 5
5 An deiner Seite. -> 6
6 Passiert nicht alle Tage. -> 7
7 Ich bin nämlich ein ausgesprochen häusliches Stück Geld. 🏡 -> 8
8 Meistens bleibe ich an einem Ort und bewege mich nicht. Faul und stabil. -> 9
9 So ist das mit echten Werten. [10]
10 Genau, die bleiben im Gedächtnis. -> 11
11 In meiner Heimat Yap wurde ich lange als Zahlungsmittel genutzt. 💰 -> 12
12 Steingeld wie mich gibt es in allen Größen, -> 13
13 handtellergroß bis haushoch. -> 14
14 Und gerade die größeren Varianten von uns sind schwer zu transportieren. 🚛 -> 15
15 Deshalb bleiben wir meistens, wo wir gerade sind. Auch, wenn wir ausgegeben werden. -> 16
16 Die Menschen merken sich einfach, wem wir gerade gehören. 🤩 -> 17
17 Ist ein bisschen wie mit der Bank. 🏦 -> 18
18 Da trägt ja auch keiner mehr einen Geldkoffer von A nach B. -> 19
19 Es werden nur ein paar Zahlen im PC verändert. -> 20
20 Weißt du, woran sich mein Wert bemisst? [21,22,23]
21 Größe -> 24 
22 Alter -> 24
23 Ob jemand beim Transport von dir ums Leben gekommen ist -> 24
24 Sehr gut, das stimmt. Unter anderem. -> 25
25 Mein Wert ist sehr individuell und wird auch z.B. anhand von Schönheit, Geschichte und Ansehen meiner Besitzer*innen bestimmt. -> 26
26 Nicht so wie heute mit dem anonymen Geld -> 27
27 von Kreditkarte bis Bitcoin... -> 28
28 das sind doch alles nur Zahlen -> 29
29 Ich bin echt, schwer und einzigartig! -> 30
30 Welche Währung findest du grundsätzlich am besten? [31,32,33]
31 Naturalien -> 34 {a1+1}
32 Bargeld -> 35 {a1+0}
33 Bitcoin -> 36 {a1-1}
34 Ja, echter ehrlicher Tauschhandel. Das ist das Wahre. Allerdings auch etwas unpraktisch, oder? -> 37
35 Nur Bares ist Wahres. Wer will schon eine ewige Spur seiner Einkäufe hinterlassen? -> 37
36 Die Zukunft ist unaufhaltbar. Aber richtig im Alltag ist das noch nicht angekommen, oder? -> 37
37 Aber ich merke schon, du gehst bewusst mit Geld um. -> 38
38 Mich allerdings ereilte ein trauriges Schicksal. Ich verlor an Wert. 😪 Weißt du warum? [39,40,41]
39 Du bist verwittert -> 42
40 Die Leute haben vergessen, wer die besaß  -> 43
41 Inflation -> 44
42 Also wirklich, ich bin exzellent erhalten! Guck dich doch mal an! Da ist der Lack schon lange ab! Nein, es ist die Inflation! 💸 -> 45
43 Mich vergisst man nicht so leicht. Pass lieber auf, dass ich dich nicht vergesse! Nein, es ist die Inflation! 💸 -> 45
44 So unverständlich das ist - ja. Inflation. Böser alter Wertverlust. 💸 -> 45
45 Die Herstellung und der Transport von Steingeld wurde Ende des 19. Jahrhunderts einfach und gefahrlos -> 46
46 Davor hat der große Aufwand mir meinen Wert garantiert. -> 47
47 Aber plötzlich wurden riesige Steingeld-Brocken schnell hergestellt. -> 48
48 Und damit haben wir altehrwürdigen Steine an Wert verloren. -> 49
49 So ist das, wenn man Geld druckt. Oder Steine. -> 50
50 Das ist übrigens auch so bei Euro, Pesos und Bitcoin -> 51
51 Nur, dass da nicht jede*r beliebig viel neues Geld erzeugen kann -> 52
52 Was also denkst du, macht Wert aus? [53,54,55]
53 Knappheit -> 56 {a0-1}
54 Stabilität -> 56 {a0-1}
55 Zustimmung -> 56 {a0+0}
56 Genau. -> 57
57 Geld muss allgemein akzeptiert werden, eine gewisse Stabilität haben und die Quantität muss begrenzt sein. -> 58
58 Ich hab meinen Wert wiedergewonnen, allerdings als historisches Objekt im Museum. -> 59
59 Du dagegen bist gegen Inflation nicht gewappnet! 💸 -> 60
60 Ständig werden unkontrolliert neue Menschen erzeugt -> 61
61 Instabile Kreaturen mit wechselnder Akzeptanz. -> 62
62 Nur gut, dass Menschen kein Geld sind... -> 63
63 Oder? [64]
64 Ja, du Stein - machs gut! -> 100

100 ||Exit
`